export const strings = {
  error: {
    fieldIsRequired: 'Field is required',
  },
  alert: {
    success: {
      title: 'Successfully saved',
    },
    danger: {
      title: 'Could not find order',
    },
    warning: {
      title: 'Data has not been saved yet.',
      text: 'Please confirm the entered data.',
    },
  },
  button: {
    login: 'Login',
    close: 'Close',
    edit: 'Edit',
    delete: 'Delete',
    next: 'Continue',
    confirm: 'Confirm',
    back: 'Go back',
    createOrder: 'New order',
    searchOrder: 'Search order',
  },
  navigation: {
    bloodSampleRegistration: 'Blood sample registration',
    phone: '+370 640 65680',
    haveQuestions: 'Have questions?',
  },
  breadcrumbs: {
    searchPatient: 'Patient search',
    registerSample: 'Sample registration',
    preview: 'Preview',
  },
  form: {
    email: 'Email address',
    password: 'Password',
    orderId: 'Order number',
    birthDate: 'Date of birth',
    search: 'Search',
    save: 'Save',
    comments: 'Comments',
    placeholderBirthDate: 'Enter date of birth',
    birthDateFormat: 'Enter date separated by hyphens, e.g.: 1999-12-08',
    select: {
      pickerPlaceholder: 'Select',
    },
  },
  header: {
    orderId: 'Order number',
  },
  bloodSampleRegistration: {
    clinic: 'Sample collection facility',
    employee: 'Sample collector',
    sampleDate: 'Sample collection date',
    sampleTime: 'Sample collection time',
    amountOfSamples: 'Number of samples',
    type: 'Sample type',
    anatomicalArea: 'Anatomical area',
    comments: 'Comments',
  },
  other: 'other',
  anatomicalArea: {
    label: 'Anatomical area',
    anatomicalAreaOptions: {
      fingerPhalanx: 'Finger phalanx',
      internalFlexionOfElbow: 'Internal flexion of elbow',
    },
  },
  sampleType: {
    label: 'Sample type',
    sampleTypeOptions: {
      capillaryBlood: 'Capillary blood',
      venousBlood: 'Venous blood',
      nasalSwab: 'Nasal swab',
      bloodSerum: 'Blood serum',
      dryBloodSample: 'Dry blood sample',
    },
  },
  bloodRegistration: {
    pickerPlaceholder: 'Select clinic and department',
  },
  gender: {
    label: 'Gender',
    male: 'Male',
    female: 'Female',
  },
  product: {
    label: 'Product',
    foodId: 'Food Intolerance Test',
    allergyChipPro: 'Molecular Allergy Test',
    allergyChip: 'Complete Allergy & Food Intolerance Bundle',
  },
  orderCreation: {
    clinic: 'Sample collection facility',
    patientName: 'Patient first name',
    patientLastName: 'Patient last name',
    birthDate: 'Date of birth',
    age: 'Age',
    product: 'Product',
    gender: 'Gender',
  },
  appUrl: 'https://partners.self.co',
};
